import { Content } from "antd/es/layout/layout";
import styled from "styled-components";


export const StyledContent = styled(Content)`
  border-bottom: 0.5px solid grey;
  margin-bottom: 10px;
  /* flex: 0.081; */

  @media (max-width: 1366px) {
    /* flex: 0.13; */
  }
`;

export const StyledContent1 = styled(Content)`
display:flex;
justify-content: flex-end;
background-Color:white;
margin-top:100px;

          /* border-Top: 1px solid grey; */
          /* flex: 0.1; */

          @media (max-width: 1366px) {
    /* flex: 0.2; */
    margin-top: 110px;
  }
`;
